<template>
  <div class="contract-information-page">
    <Title currentPageTitle="维护签约任务信息"></Title>
    <!-- 申请信息 -->
    <div class="contract-base-box">
      <p class="contract-base-name">申请信息</p>
      <div class="contract-apply-box">
        <div class="contract-apply-item"><span>合同名称：</span>{{ formData.contractName }}</div>
        <div class="contract-apply-item"><span>申请人：</span>{{ submitStaffName }}</div>
        <div class="contract-apply-item"><span>签约时间：</span>{{ formData.signDate | getDate }}</div>
        <div class="contract-apply-item"><span>合同有效期至：</span>{{ formData.validityDate | getDate }}</div>
      </div>
      <!-- 附件 -->
      <div class="contract-base-box">
        <div class="contract-apply-file">
          <span>合同附件：</span>
          <div>
            <div v-for="(item, index) in fileList" :key="index">
              <div class="contract-file-inform">
                <img
                  width="32"
                  height="32"
                  class="mr10"
                  :src="
                    item.type == 'word'
                      ? require('../../assets/images/word_icon.png')
                      : require('../../assets/images/pdf_icon.png')
                  "
                  alt=""
                /><span> {{ item.name }}</span
                ><span class="fontC-4fa1a4 c-pointer ml10" @click="toSee(item, index)">查看详情</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <img
        v-if="approveState && approveState !== 'N'"
        class="approve-img"
        :src="getApproveImg()"
        alt=""
      />
    </div>
    <!-- 合同信息 -->
    <div class="contract-base-box">
      <p class="contract-base-name">合同信息</p>
      <el-row :gutter="24">
        <el-col :span="12">
          <span class="contract-base-title">甲方名称：</span>
          <div class="contract-base-content">{{ formData.tenantName }}</div>
        </el-col>
        <el-col :span="12">
          <span class="contract-base-title">乙方名称：</span>
          <div class="contract-base-content">{{ formData.serviceTenantName }}</div>
        </el-col>
        <el-col :span="12">
          <span class="contract-base-title">公司类型：</span>
          <div class="contract-base-content">{{ formData.enterpriseCate | commonFilterName('平台企业类型') }}</div>
        </el-col>
        <el-col :span="12">
          <span class="contract-base-title">合同类型：</span>
          <div class="contract-base-content">{{ formData.contractType | commonFilterName('合同类型') }}</div>
        </el-col>
        <el-col :span="12">
          <span class="contract-base-title">业务类型：</span>
          <div class="contract-base-content">{{ formData.contractContentType == '1' ? '业务收入' : '业务支出' }}</div>
        </el-col>
        <el-col :span="12">
          <span class="contract-base-title">业务类型内容：</span>
          <div class="contract-base-content" v-if="formData.contractContentType == '1'">{{ formData.contractContent | commonFilterName('业务收入类型') }}</div>
          <div class="contract-base-content" v-else>{{ formData.contractContent | commonFilterName('业务支出类型') }}</div>
        </el-col>
        <el-col :span="12">
          <span class="contract-base-title">项目经理：</span>
          <div class="contract-base-content">{{ formData.projectManagerName || '-'}}</div>
        </el-col>
        <el-col :span="12">
          <span class="contract-base-title">合同内容：</span>
          <div class="contract-base-content">{{ formData.contractContent | commonFilterName('合同内容分类') }}</div>
        </el-col>
        <el-col :span="12">
          <span class="contract-base-title">合同金额(元)：</span>
          <div class="contract-base-content">{{ formData.contractMoney | numDigit }}</div>
        </el-col>
        <el-col :span="12">
          <span class="contract-base-title">发票方式：</span>
          <div class="contract-base-content">{{ formData.invoiceMode }}</div>
        </el-col>
        <!-- <el-col :span="12">
          <span class="contract-base-title">支付方式：</span>
          <div class="contract-base-content">{{ formData.upstreamPayType | commonFilterName('付款方式') }}</div>
        </el-col> -->
        <el-col :span="12">
          <span class="contract-base-title">结算依据：</span>
          <div class="contract-base-content">{{ formData.balanceBasis }}</div>
        </el-col>
        <el-col :span="12">
          <span class="contract-base-title">维保条件：</span>
          <div class="contract-base-content">{{ formData.maintainCondition | commonFilterName('维保条件') }}</div>
        </el-col>
        <el-col :span="12">
          <span class="contract-base-title">是否垫资：</span>
          <div class="contract-base-content">{{ formData.isAdvanceMoney | getVisible }}</div>
        </el-col>
        <el-col :span="12">
          <span class="contract-base-title">任务价格是否含税：</span>
          <div class="contract-base-content">{{ formData.isContainTax | getVisible }}</div>
        </el-col>
        <el-col :span="12">
          <span class="contract-base-title">是否补充协议：</span>
          <div class="contract-base-content">{{ formData.isSupplementAgreement | getVisible }}</div>
        </el-col>
      </el-row>
    </div>
    <!-- 产品信息 -->
    <div class="contract-base-box">
      <p class="contract-base-name">产品信息</p>
      <el-row :gutter="24" class="mb10">
        <el-col :span="24">
          <span class="contract-base-title">产品名称：</span>
          <div class="contract-base-content">{{getProductName(formData.contractProductList) }}</div>
        </el-col>
       
      </el-row>
    </div>
    <!-- 付款方式 -->
    <div class="contract-base-box">
      <p class="contract-base-name">付款方式</p>
      <el-row :gutter="24" class="mb10" >
        <el-col :span="12">
          <span class="contract-base-title">付款方式：</span>
          <div class="contract-base-content">{{ formData.payType | commonFilterName('付款方式') }}</div>
        </el-col>
      </el-row>
      <el-row :gutter="24" class="mb10" v-if="formData.payType !== '1'" v-for="(item, index) in payTypeJsonList" :key="index">
        <el-col :span="12">
          <span class="contract-base-title">回款方式：</span>
          <div class="contract-base-content" v-if="formData.payType == '4'">{{ item.selectType | commonFilterName('费用类型') }}</div>
          <div class="contract-base-content" v-if="formData.payType == '2'">{{ item.selectType | commonFilterName('季度选项')}}</div>
          <div class="contract-base-content" v-if="formData.payType == '3'">{{ item.selectType | commonFilterName('年度选项')}}</div>
        </el-col>
        <el-col :span="12">
          <span class="contract-base-title">{{formData.payType !== '4' ? '回款金额(元)' : '回款比例(%)'}}：</span>
          <div class="contract-base-content">{{ item.selectValue }}</div>
        </el-col>
      </el-row>
      <el-row :gutter="24" class="mb10" v-if="formData.payType == '1'" >
         <el-col :span="12">
          <span class="contract-base-title">收费比例(%)：</span>
          <div class="contract-base-content">{{ formData.chargeRate | numDigit }}</div>
        </el-col>
        <el-col :span="12">
          <span class="contract-base-title">下发扣除税点(%)：</span>
          <div class="contract-base-content">{{ formData.sendTaxDeduction | numDigit }}</div>
        </el-col>
        <el-col :span="12">
          <span class="contract-base-title">是否内扣：</span>
          <div class="contract-base-content">{{ formData.isInsideDeduction | getVisible }}</div>
        </el-col>
      </el-row>
    </div>
    <!-- 银行信息 -->
    <div class="contract-base-box">
      <p class="contract-base-name">银行信息</p>
      <el-row :gutter="24" class="mb10" v-for="(item, index) in formData.contractBankList" :key="index">
        <el-col :span="12">
          <span class="contract-base-title">开户银行：</span>
          <div class="contract-base-content">{{ item.bankName }}</div>
        </el-col>
        <el-col :span="12">
          <span class="contract-base-title">开户账号：</span>
          <div class="contract-base-content">{{ item.bankAccount }}</div>
        </el-col>
        <el-col :span="12">
          <span class="contract-base-title">开户行号：</span>
          <div class="contract-base-content">{{ item.bankNo }}</div>
        </el-col>
        <el-col :span="12">
          <span class="contract-base-title">税号：</span>
          <div class="contract-base-content">{{ item.bankTaxNo }}</div>
        </el-col>
      </el-row>
    </div>
    <!-- 签约任务 -->
    <div class="contract-base-box" v-show="formData.contractTaskDetailList&&formData.contractTaskDetailList.length">
      <p class="contract-base-name">签约任务</p>
      <div class="content-main-box"  style="height:auto;"> 
          <el-table border  stripe :data="formData.contractTaskDetailList">
            <el-table-column label="序号" width="60" header-align="center" align="center" fixed="left">
              <template slot-scope="scope">
                {{ scope.$index + 1 }}
              </template>
            </el-table-column>
              <!-- 任务名称 -->
              <el-table-column :resizable="false" show-overflow-tooltip label="任务名称" width="220" header-align="center" align="left">
                  <template slot-scope="scope">
                      <!-- {{ scope.row.oldTaskContentName || '-' }} -->
                      {{ scope.row |taskNameFilter }}
                  </template>
              </el-table-column>
              <!-- 任务名称 -->
              <el-table-column :resizable="false" label="项目任务名称" width="180" header-align="center" align="left">
                <template slot-scope="scope">
                      {{ scope.row.taskContentName || '-' }}
                  </template>
              </el-table-column>
              <!-- 任务价格(元) -->
              <el-table-column :resizable="false" show-overflow-tooltip label="任务价格(元)" width="160" header-align="center" align="right">
            
                  <template slot-scope="scope">
                    <div  v-if="scope.row.priceType==2">
                      {{  scope.row.taskPrice | numDigit }} -  {{  scope.row.maxTaskPrice | numDigit }}
                    </div>
                    <div  v-if="scope.row.priceType==1">
                      {{  scope.row.taskPrice | numDigit }}
                    </div>
                  </template>

              </el-table-column>
              <!-- 备注 -->
              <el-table-column :resizable="false" show-overflow-tooltip label="备注" width="100" header-align="center" align="left">
                  <template slot-scope="scope">
                      {{ scope.row.taskDescription || '-' }}
                  </template>
              </el-table-column>
      

          </el-table>
      </div>
      <!-- <el-row :gutter="24" class="mb10" v-for="(item, index) in formData.contractTaskDetailList" :key="index">
        <el-col :span="12">
          <span class="contract-base-title">任务名称：</span>
          <div class="contract-base-content">{{ item.oldTaskContentName }}</div>
        </el-col>
        <el-col :span="12">
          <span class="contract-base-title">任务名称：</span>
          <div class="contract-base-content">{{ item.taskContentName }}</div>
        </el-col>
        <el-col :span="12">
          <span class="contract-base-title">任务价格(元)：</span>
          <div class="contract-base-content">{{ item.taskPrice | numDigit }}</div>
        </el-col>
        <el-col :span="12">
          <span class="contract-base-title">备注：</span>
          <div class="contract-base-content">{{ item.taskDescription }}</div>
        </el-col>
      </el-row> -->
    </div>
    <!-- 流程 -->
    <div style="padding-left: 16px; background: #fff; margin-top: 4px">
      <iframe v-show="iframeSh" :src="srcs" class="iframe-sty"></iframe>
    </div>
    <!-- 提交 -->
    <div class="submit-btn-box" v-if="formData">
      <el-button type="borderBlack" size="small" @click="$router.go(-1)">取消</el-button>
      <el-button type="borderRed" size="small" v-show="getBtnState('approval') == 'approval'" @click="toReject"
        >驳回</el-button
      >
      <el-button type="importNew" size="small" v-show="getBtnState('approval') == 'approval'" @click="toPass"
        >通过</el-button
      >
      <el-button type="importNew" size="small" v-show="getBtnState('again') == 'again'" @click="reSubmit"
        >重新提交</el-button
      >
      <el-button type="importNew" size="small" v-show="getBtnState('revoke') == 'revoke'" @click="toRevoke"
        >撤销</el-button
      >
    </div>
    <el-dialog title="驳回流程" :visible.sync="rejectDialogVisible" width="30%" top="15%">
      <el-input type="textarea" :rows="5" placeholder="输入驳回理由（必填）" v-model="approveSuggest" maxlength="100"> </el-input>
      <span slot="footer" class="dialog-footer">
        <el-button type="info" class="w100f" @click="toRejectSubmit()">驳回</el-button>
      </span>
    </el-dialog>
    <el-dialog title="通过流程" :visible.sync="passDialogVisible" width="30%" top="15%">
      <el-input type="textarea" :rows="5" placeholder="输入通过备注（非必填）" v-model="approveSuggest" maxlength="100"> </el-input>
      <span slot="footer" class="dialog-footer">
        <el-button type="info" class="w100f" @click="toPassSubmit()">通过</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { bpmnroute } from '@/api/apiRoute';
import Title from '@/components/title/title.vue';
import workFlowCommon from '@/uilt/workFlowCommon';
export default {
  components: {
    Title,
  },
  data() {
    return {
      flowType: '00011',
      rejectDialogVisible: false,
      passDialogVisible: false,
      approveSuggest: '',
      formData: {},
      fileList: [],
      contractFileName: '',
      //流程
      srcs: '',
      processInstanceId: '',
      iframeSh: true,
      currentStaffGuid: null, //当前登录人guid
      currentApproveGuid:null,//当前流程ID,
      submitStaffName:null,
      submitStaffGuid:null,
      approveState:null,
      payTypeJsonList:[]
    };
  },
  filters:{
    taskNameFilter(val) {
      console.log('val',val);
      let str='-'
      if(val.oldTaskContentName){
        // if(val.taskTemplateBizState=='S'){
        //   str=val.oldTaskContentName +' (已禁用)'
        // }else{
        //   str=val.oldTaskContentName
        // }
        str=val.oldTaskContentName + (val.taskTemplateBizState=='S'?' (已禁用)' :'') + (val.bizState=='S'?' (已作废)' :'')
        
      }
      return str
    },
  },
  created() {
    let userinfo = JSON.parse(localStorage.userInfo);
    this.currentStaffGuid = userinfo.staffGuid;
    this.approveState = this.$route.query.approveState;
    this.submitStaffName = this.$route.query.submitStaffName;//提交人
    this.submitStaffGuid = this.$route.query.submitStaffGuid;
    this.currentApproveGuid = this.$route.query.approveGuid;//当前流程id
    this.getContractDetail();
    this.getBpmnUrl();
  },
  methods: {
    //状态图片
    getApproveImg() {
      return workFlowCommon.getApproveImg(this.approveState);
    },
    //查看附件
    toSee(item, index) {
      let path = item.path;
      if (path.indexOf('.pdf' || '.PDF') > -1) {
        window.open(path);
      } else {
        window.open('https://view.officeapps.live.com/op/view.aspx?src=' + encodeURIComponent(path));
      }
    },
    //获取操作按钮显隐
    getBtnState(btnType) {
      return workFlowCommon.getBtnState(
        btnType,//按钮类型
        this.approveState,//审批状态
        this.$route.query.approveStaffGuid,//当前审批人id
        this.currentStaffGuid,//当前登录人id
        this.formData.staffGuid,//提交人id
        this.formData.bizApproveState//业务状态
      );
    },
    //获取详情
    getContractDetail() {
      let self = this;
      let type='2'
      self.api.get(`/${serverConfig.msCustomerService}/contract/detail-approve-task?guid=${this.$route.query.contractGuid}&selectType=${type}`).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.formData = res.data.data;
          self.payTypeJsonList = JSON.parse(self.formData.payTypeJson);
          (self.formData.signDate = self.$moment(self.formData.signDate).format('YYYY-MM-DD')), //签约时间
            (self.formData.validityDate = self.$moment(self.formData.validityDate).format('YYYY-MM-DD')); //合同有效期
          if (self.formData.contractUrl) {//文件展示
            self.fileList = JSON.parse(self.formData.contractUrl);
            self.fileList.forEach((i) => {
              if (i.path.indexOf('.pdf' || '.PDF') > -1) {
                i.type = 'pdf';
              } else {
                i.type = 'word';
              }
            });
          }
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    getProductName(list){
      let nameList = [];
      if(list && list.length > 0){
        list.forEach(i=>{
          nameList.push(i.productName);
        })
      }
      
      return nameList.join(' , ')
    },
    getBpmnUrl() {
      if (this.$route.query.camundaInstanceId && this.$route.query.camundaDeploymentId) {
        this.srcs =
          bpmnroute +
          '/iframeBpmn?processInstanceId=' +
          this.$route.query.camundaInstanceId +
          '&camundaDeploymentId=' +
          this.$route.query.camundaDeploymentId +
          '&token=' +
          localStorage.token;
        console.log(this.srcs)
      } else {
        this.iframeSh = false;
      }
    },
    //撤销
    toRevoke() {
      let self = this;
      self
        .$confirm(messageConfig.FLOW_IS_CANCEL, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
        .then(() => {
          let query = {
            guid: self.currentApproveGuid,
            flowType: self.flowType,
            approveStaffGuid: self.currentStaffGuid,
          };
          self.fullscreenLoading = true;
          self.api.postJson(`/${serverConfig.msSalesPerformService}/work-flow/data/canal-flow`, query).then((res) => {
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              self.fullscreenLoading = false;
              self.$message.success(messageConfig.FLOW_CANCEL);
              sessionStorage.refresh = 1;
              self.$router.go(-1);
            } else {
              self.$message.error(res.data.msg);
            }
          });
        })
        .catch(() => {
          self.$message({
            type: 'info',
            message: '已取消操作！',
          });
        });
    },
    //重新提交
    reSubmit() {
      this.$router.push({
        path: '/contractSealAdd',
        query: this.$route.query
      });
    },
    toPass() {
      let self = this;
      self.approveSuggest = '';
      self.passDialogVisible = true;
    },
    toReject() {
      let self = this;
      self.approveSuggest = '';
      self.rejectDialogVisible = true;
    },
    //通过
    toPassSubmit() {
      let self = this;
      let query = {
        guid: self.currentApproveGuid,
        flowType: self.flowType,
        approveSuggest: self.approveSuggest,
        approveStaffGuid: self.currentStaffGuid,
      };
      self.fullscreenLoading = true;
      self.api.postJson(`/${serverConfig.msSalesPerformService}/work-flow/data/allow-flow`, query).then((res) => {
        self.fullscreenLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.$message.success(messageConfig.FLOW_PASS);
          sessionStorage.refresh = 1;
          self.$router.go(-1);
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    //驳回
    toRejectSubmit() {
      let self = this;
      if (self.approveSuggest == '') {
        self.$message.error('请填写驳回理由！');
        return;
      }
      let query = {
        guid: self.currentApproveGuid,
        flowType: self.flowType,
        approveSuggest: self.approveSuggest,
        approveStaffGuid: self.currentStaffGuid,
      };
      self.fullscreenLoading = true;
      self.api.postJson(`/${serverConfig.msSalesPerformService}/work-flow/data/backup-flow`, query).then((res) => {
        self.fullscreenLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.$message.success(messageConfig.FLOW_REJECT);
          sessionStorage.refresh = 1;
          self.rejectDialogVisible = false;
          self.$router.go(-1);
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
  },
};
</script>
<style scoped>
.contract-information-page {
  overflow: auto;
}
.contract-base-box {
  position: relative;
  padding: 10px 16px;
  margin-top: 4px;
  background: #fff;
}
.contract-base-name {
  font-size: 16px;
  color: #212121;
  text-align: left;
  margin: 8px 0 14px 0;
}
/* 申请信息 */
.contract-apply-box {
  display: flex;
  padding-left: 10px;
  margin-bottom: 25px;
}
.contract-apply-item {
  font-size: 14px;
  color: #666666;
  padding: 0 20px;
  box-sizing: border-box;
  border-right: 1px solid #e5e5e5;
}
.contract-apply-file {
  display: flex;
  font-size: 14px;
  color: #666666;
  padding: 0 20px;
  box-sizing: border-box;
}
.contract-file-inform {
  display: flex;
  align-items: center;
  margin-bottom: 23px;
}
.approve-img {
  position: absolute;
  top: 50px;
  right: 60px;
  width: 78px;
  height: 78px;
}
/* 合同信息 */
.contract-base-box .el-col-12 ,.contract-base-box .el-col-24{
  display: flex;
  line-height: 22px;
  margin-bottom: 20px;
}
.el-col-12:nth-child(2n + 1) .contract-base-title ,.el-col-24:nth-child(2n + 1) .contract-base-title{
  flex-shrink: 0;
  width: 100px;
  text-align: right;
  font-size: 14px;
  color: #666666;
}
.el-col-12:nth-child(2n) .contract-base-title ,.el-col-12:nth-child(2n) .contract-base-title{
  flex-shrink: 0;
  width: 140px;
  text-align: right;
  font-size: 14px;
  color: #666666;
}
.contract-base-content {
  color: #212121;
  text-align: left;
}
/* 流程 */
.iframe-sty {
  width: 100%;
  height: 500px;
  border: none;
  /* background:grey; */
}
.submit-btn-box {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 60px;
  border-top: 1px solid #d9d9d9;
  background: #fff;
}
</style>
